module.exports = __webpack_public_path__ + "static/media/nexa-rust.sans-black.04783264.otf";